import TableFooter from './TableFooter.view';
export default TableFooter;
